import DropStorageFilesContainer from './DropStorageFilesContainer';

export default DropStorageFilesContainer;
